<ng-container *ngIf="antwoordResultaat">
  <ul *ngIf="hoofdAntwoorden" [ngClass]="{'single-antwoorden': hoofdAntwoorden.length === 1}">
    <li data-hj-suppress *ngFor="let hoofdAntwoord of hoofdAntwoorden">
      <div>{{hoofdAntwoord.titel}}</div>
      <div *ngFor='let subAntwoord of getSubAntwoorden(hoofdAntwoord)'>
        <app-progress *ngIf='subAntwoord.sub_control_type === doorvraagType.Slider' minText="0%" maxText="100%" [max]='100' [value]='getAntwoordResultaat(subAntwoord)'>
        </app-progress>
        <div *ngIf='subAntwoord.sub_control_type === doorvraagType.TextArea'>{{getAntwoordResultaat(subAntwoord)}}</div>
      </div>
    </li>
  </ul>
</ng-container>
